export const PAGE_TITLE = 'PAGE_TITLE';

export const PROGRESS_START = 'PROGRESS_START';
export const PROGRESS_FINISH = 'PROGRESS_FINISH';
export const PROGRESS_FAIL = 'PROGRESS_FAIL';